import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerEgresosReporteAction, obtenerEgresosMensualesAction } from "../../../ducks/reportesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { makeStyles } from '@material-ui/core/styles'
import { formatDinero } from "./../../../utils/formatDinero"
import { Card, CardContent, Grid, Typography } from "@material-ui/core"
import { FormatoFecha } from "../../../utils/FormatFecha"
import Grafica from "../Utilidad/Grafica"
import TablaEgresosMxn from "../TablaEgresosMxn"
import TablaEgresosUsd from "../TablaEgresoUsd"
import CabeceraEgresos from "../CabeceraEgresos"
import ButtonReporteEgresosMxn from "../ButtonReporteEgresosMxn"
import ButtonReporteEgresosUsd from "../ButtonReporteEgresosUsd"
import GraficaBarras from "../../../global/GraficaBarras"

const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    root: {
        width: '60%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    rootGrafica: {
        width: '40%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
})
const useTratarDataMensualesUSD = () => {
    const { metricaEgresosMensuales } = useSelector(store => store.reportes)
    const egresosMensuales = metricaEgresosMensuales ?? []
    const labels = egresosMensuales.map(valor => {
        return `${FormatoFecha({ date: new Date(valor.Anho, valor.Mes - 1), formato: "MMM yyyy" }).toUpperCase()}`
    })
    const data = {
        labels,
        datasets: [
            {
                label: 'Reservas USD',
                data: egresosMensuales.map((valor) => valor.TotReservaUSD),
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                stack: 'Stack 0',
            },
            {
                label: 'Aereos USD',
                data: egresosMensuales.map((valor) => valor.TotAereoUSD),
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                stack: 'Stack 0',
            },
            {
                label: 'Liquidacion USD',
                data: egresosMensuales.map((valor) => valor.TotLiquidacionUSD),
                backgroundColor: 'rgba(255, 206, 86, 0.2)',
                borderColor: 'rgba(255, 206, 86, 1)',
                stack: 'Stack 0',
            },
        ],
    }
    return [labels, data]
}
const useTratarDataMensualesMXN = () => {
    const { metricaEgresosMensuales } = useSelector(store => store.reportes)
    const egresosMensuales = metricaEgresosMensuales ?? []
    const labels = egresosMensuales.map(valor => {
        return `${FormatoFecha({ date: new Date(valor.Anho, valor.Mes - 1), formato: "MMM yyyy" }).toUpperCase()}`
    })
    const data = {
        labels,
        datasets: [
            {
                label: 'Reservas MXN',
                data: egresosMensuales.map((valor) => valor.TotReservaMXN),
                backgroundColor: 'rgba(255, 105, 97, 0.2 )',
                borderColor: 'rgba(75, 192, 192, 1)',
                stack: 'Stack 1',
            },
            {
                label: 'Aereos MXN',
                data: egresosMensuales.map((valor) => valor.TotAereoMXN),
                backgroundColor: 'rgba(153, 102, 255, 0.2)',
                borderColor: 'rgba(54, 162, 235, 1)',
                stack: 'Stack 1',
            },
            {
                label: 'Liquidacion MXN',
                data: egresosMensuales.map((valor) => valor.TotLiquidacionMXN),
                backgroundColor: 'rgba(255,169,233, 0.2)',
                borderColor: 'rgba(255, 206, 86, 1)',
                stack: 'Stack 1',
            },
        ],
    }
    return [labels, data]
}
const useObtenerEgresos = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerEgresosReporteAction({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const useObtenerEgresosMensuales = ({ fechaInicio, fechaFinal }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "Obteniendo información..." }))
        dispatch(obtenerEgresosMensualesAction({ FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" }), FechaIni: FormatoFecha({ date: fechaInicio, formato: "MMddyyyy" }) })).then(Resposne => {
            dispatch(offLoadAction())
        })
    }, [dispatch, fechaInicio, fechaFinal])
}
const calcularProcentaje = ({ monto, total }) => {
    let resultado = monto * 100
    resultado = resultado / total
    return (resultado < 0) ? resultado * -1 : resultado
}
const Egresos = () => {
    const classes = useStyles()
    const { metricaEgresos, egresosFechaFin, egresosFechaInicio } = useSelector(store => store.reportes)
    useObtenerEgresos({ fechaFinal: egresosFechaFin, fechaInicio: egresosFechaInicio })
    useObtenerEgresosMensuales({ fechaFinal: egresosFechaFin, fechaInicio: egresosFechaInicio })
    const [ labelsUSD, dataUSD] = useTratarDataMensualesUSD()
    const [ labelsMXN, dataMXN] = useTratarDataMensualesMXN()
    return (
        <>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12}>
                    <CabeceraEgresos />
                </Grid>
            </Grid>
            <Grid container style={{marginBottom: "1rem"}} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <GraficaBarras data={dataUSD} />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <GraficaBarras data={dataMXN} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container>
                <Grid container item xs={12} alignContent="center" justifyContent="flex-end" spacing={1}>
                    <Grid item>
                        <ButtonReporteEgresosUsd />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.container}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="h6" >
                                                Egresos USD
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de egresos: {metricaEgresos.CanEgresosUSD}
                                            </Typography>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Monto de egresos: {formatDinero(metricaEgresos.TotEgresosUSD)} USD
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Grid container>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Reservas:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {metricaEgresos.CanReservaUSD}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Aereos:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {metricaEgresos.CanAereoUSD}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Liquidaciones:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {metricaEgresos.CanLiquidacionUSD}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Monto Reservas:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {formatDinero(metricaEgresos.TotReservaUSD)} USD
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Monto Aereos:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {formatDinero(metricaEgresos.TotAereoUSD)} USD
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Monto Liquidaciones:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {formatDinero(metricaEgresos.TotLiquidacionUSD)} USD
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card className={classes.rootGrafica}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem", position: "relative", margin: "auto", height: "27vh", width: "27vw" }}>
                                            <Grafica
                                                label="%"
                                                labels={['Reservas', 'Aereos', 'Liquidaciones']}
                                                valores={[
                                                    calcularProcentaje({ monto: metricaEgresos.TotReservaUSD, total: metricaEgresos.TotEgresosUSD }),
                                                    calcularProcentaje({ monto: metricaEgresos.TotAereoUSD, total: metricaEgresos.TotEgresosUSD }),
                                                    calcularProcentaje({ monto: metricaEgresos.TotLiquidacionUSD, total: metricaEgresos.TotEgresosUSD }),
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <TablaEgresosUsd />
                </Grid>
                <Grid container item xs={12} style={{ marginTop: "2rem" }} alignContent="center" justifyContent="flex-end" spacing={1}>
                    <Grid item>
                        <ButtonReporteEgresosMxn />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.container}>
                        <Card className={classes.root}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography color="textSecondary" variant="h6" >
                                                Egresos MXN
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ marginBottom: "0" }}>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Total de Egresos: {metricaEgresos.CanEgresosMXN}
                                            </Typography>
                                            <Typography color="textSecondary" variant="subtitle2">
                                                Monto de Egresos: {formatDinero(metricaEgresos.TotEgresosMXN)} MXN
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Grid container>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Reservas:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {metricaEgresos.CanReservaMXN}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Aereos:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {metricaEgresos.CanAereoMXN}
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Liquidaciones:
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {metricaEgresos.CanLiquidacionMXN}
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <div className={classes.pos} >
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Reservas:
                                                        </Typography>
                                                        <Typography color="textPrimary" >
                                                            {formatDinero(metricaEgresos.TotReservaMXN)} MXN
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Aereos
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {formatDinero(metricaEgresos.TotAereoMXN)} MXN
                                                        </Typography>
                                                    </div>
                                                    <div className={classes.pos}>
                                                        <Typography color="textSecondary" variant="subtitle2">
                                                            Total Liquidacion
                                                        </Typography>
                                                        <Typography color="textPrimary">
                                                            {formatDinero(metricaEgresos.TotLiquidacionMXN)} MXN
                                                        </Typography>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                        <Card className={classes.rootGrafica}>
                            <CardContent>
                                <Grid container>
                                    <Grid item xs={12} >
                                        <div style={{ marginBottom: "1rem", position: "relative", margin: "auto", height: "27vh", width: "27vw" }}>
                                            <Grafica
                                                label="%"
                                                labels={['Reservas', 'Aereos', 'Liquidaciones']}
                                                valores={[
                                                    calcularProcentaje({ monto: metricaEgresos.TotReservaMXN, total: metricaEgresos.TotEgresosMXN }),
                                                    calcularProcentaje({ monto: metricaEgresos.TotAereoMXN, total: metricaEgresos.TotEgresosMXN }),
                                                    calcularProcentaje({ monto: metricaEgresos.TotLiquidacionMXN, total: metricaEgresos.TotEgresosMXN }),
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <TablaEgresosMxn />
                </Grid>
            </Grid>
        </>
    )
}
export default Egresos